window.addEventListener('load', function () {
  var PHAI = ['caibang', 'vodang', 'thieulam', 'ngami', 'daiphongduong'];

  var $section = $('#x5-frame4');
  if ($section.length === 0 || $section.find('.mp-emblem').length === 0) return;

  var $play = $section.find('.mp-play');
  var defaultVideoLink = $play.attr('data-link') || '';

  var VIDEO_LINK = {
    caibang: '',
    vodang: '',
    daiphongduong: '',
    ngami: '',
    thieulam: ''
  };

  // Lazy: set src từ data-src lần đầu chọn phái (ảnh nền nặng, chỉ tải khi cần)
  function ensureLoaded(phai) {
    $section.find('.mp-bg--' + phai + ', .mp-bg-mb--' + phai).each(function () {
      if (!this.getAttribute('src') && this.getAttribute('data-src')) {
        this.setAttribute('src', this.getAttribute('data-src'));
      }
    });
  }

  function selectPhai(phai) {
    if (PHAI.indexOf(phai) === -1) return;
    ensureLoaded(phai);

    PHAI.forEach(function (p) { $section.removeClass('is-' + p); });
    $section.addClass('is-' + phai);

    $section.find('.mp-emblem').removeClass('active');
    $section.find('.mp-emblem--' + phai).addClass('active');

    $play.attr('data-link', VIDEO_LINK[phai] || defaultVideoLink);
  }

  $section.on('click', '.mp-emblem', function (e) {
    e.preventDefault();
    selectPhai(String($(this).data('phai')));
  });

  $play.on('click', function () {
    var link = $play.attr('data-link');
    if (link) Fancybox.show([{ src: link }]);
  });

  selectPhai('caibang');
});
